import React, { useState, useEffect, useRef } from "react";
import { BsQrCodeScan } from "react-icons/bs";
import CustomTable from "../../../widgets/table/index";
import HeaderSection from "../../common/headerSection";
import PageHeader from "../../common/pageHeader";
import Modal from "react-bootstrap/Modal";
import { TfiClose } from "react-icons/tfi";
import { useTranslation } from "react-i18next";
import QrReader from "react-qr-reader";
import { areaService } from "../../../service/areaServices";
import Pagination from "../../../widgets/pagination";
import { useDispatch, useSelector } from "react-redux";
import { RootState, setAreaId, setAreaName , setEquipmentId, setScanAreaName} from "../../../store/store";
import { userService } from "../../../service/plateServices";
import CustomToast from "../../../widgets/toaster";
import { columns } from "./partials/columns";
import moment from 'moment';
import { IoSearchSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { DEFAULT_PAGE_SIZE } from "../../../constants/constants";
import CustomLoader from "../../../widgets/loader/loader";

const ScanArea = () => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const textFieldRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (textFieldRef.current) {
      textFieldRef.current.focus();
    }
  }, []);

  const [scanCode, setScanCode] = useState("");
  const [showScan, setShowScan] = useState(false);
  const [webcamResult, setWebCamResult] = useState<string | null>(null);
  const [stream, setStream] = useState(false);
  const [videoDimensions, setVideoDimensions] = useState<{
    width: number;
    height: number;
  } | null>(null);
  const [useEffectRequired, setUseEffectRequired] = useState(false);

  // pagination
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const areaId = useSelector((state: RootState) => state.area.areaId);
  const areaName = useSelector((state: RootState) => state.area.areaName);
  const scanAreaName = useSelector((state: RootState) => state.area.scanAreaName);
  const [capacityDetails , setCapacityDetails] = useState("")

  //pagination in Scan Area
  const [pageHistory, setPageHistory] = useState(1)
  const [pageSizeHistory, setPageSizeHistory] = useState(DEFAULT_PAGE_SIZE)
  const [totalPagesHistory, setTotalPagesHistory] = useState(0)
  const [totalElementsHistory, setTotalElementsHistory] = useState(0)
  //Scan Area
  const [plateDetailsHistory, setPlateDetailsHistory] = useState<Array<any>>([]);
  const [keyWordHistory, setkeyWordHistory] = useState("")
  const [currentLocationId , setCurrentLocationId] = useState("");
  const [autoclaveStatus , setAutoclavestatus] = useState(14)
  //fields to store the values get from getScanbyArea Api
  const [areaByScan, setAreaByScan] = useState({
    area_name: "",
    available_incubators: "",
    incubator_capacity: "",
    area_id : "",
    incubator_policy_duration: "",
    activity_count : "",
    available_node_count: "",
    capacity : ""
  });
  // const [scanAreaName, setScanAreaName] = useState("");
  const [showToast, setShowToast] = useState(false)
  const [toastMessage, setToastMessage] = useState("")
  const [toastType, setToastType] = useState("");
  const [selectedScanCode, setSelectedScanCode] = useState("");
  const [hasNavigated, setHasNavigated] = useState(false);
  const [temperatureRange , setTemperatureRange] = useState("")
  const [loader, setLoader] = useState(false);

  //handle webcam errors in scan qr section 
  const webCamError = (error: any) => {
    console.log(error);
  };

  //handle web cam result 
  const webCamScan = (result: any) => {
    if (result) {
      const scanData = JSON.parse(result);
      const id = scanData.id || scanData.ID
      setWebCamResult(result);
      setShowScan(false);
      closeCamera();
      if(id){
        getAreaByScan(id , "");
      }else{
        getAreaByScan(id , "");
      }
    }
  };

  //handle open camera modal 
  const handleModalOpen = () => {
    setWebCamResult("");
    setShowScan(true);
    openCamera();
  };

  //set the live stream when modal opens 
  const openCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });
      const track = stream.getVideoTracks()[0];

      if (track) {
        const settings = track.getSettings();
        const width = settings.width || 0;
        const height = settings.height || 0;
        setVideoDimensions({ width, height });
        setStream(true);
      } else {
        console.error("Video track not found.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  //on close click camera modal 
  const closeCamera = () => {
    // Access the MediaStream from the video element
    const videoElement = document.querySelector("video");
    const mediaStream = videoElement?.srcObject;

    if (mediaStream instanceof MediaStream) {
      // Get the tracks and stop them if the mediaStream exists
      const tracks = mediaStream.getTracks();

      tracks.forEach((track) => track.stop());

      // Close the camera
      setStream(false);
    } else {
      console.error("Video element or media stream not found.");
    }
  };

  //clear the entered scanned data 
  const clearSelectedData = () => {
    window.location.reload();
  };

  //change in the qr values trigger api for fetch area details 
  const handleScancodeChange = (result:any) => {
    setScanCode(result)
    try {
      const parsedResult = JSON.parse(result);
      if (typeof parsedResult === 'object') {
        const code = parsedResult.code || parsedResult.CODE
        setScanCode(code)
        webCamScan(result);
      }
    } catch (error) {
      console.error('Error parsing JSON:', error);
    }
  }

  //get area and location details using the searched result
  const getAreaByScan = async (id: any, location_type: any) => {
    setLoader(true);
    try {
      const response = await areaService.getAreaByScan(id, location_type);
  
      // Check for response status 200
      if (response.status && response.statusCode === 200) {
        try {
          // Set the area details based on location type
          setAreaByScan(response.data);
          setCurrentLocationId(response.data.id);
          dispatch(setAreaId(response.data.id));
          dispatch(setAreaName(response.data.location_type));
          dispatch(setEquipmentId(response.data.equipment_id));
          setHasNavigated(true)
          if (response.data.location_type == 8) {
            dispatch(setScanAreaName(response.data.lab_area_name));
            setCapacityDetails("");  
          } else if (response.data.location_type == 9) {
            dispatch(setScanAreaName(response.data.autoclave_area_name));
            setCapacityDetails(`${response.data.busy_node_count} / ${response.data.capacity}`);
          } else {
            dispatch(setScanAreaName(response.data.incubator_name));
            setCapacityDetails(`${response.data.busy_node_count} / ${response.data.incubator_capacity}`);
            setTemperatureRange(`b/w ${response.data.min_temperature} - ${response.data.max_temperature}`)
            ListPlateDetails(response.data.id)
          }
          
          let timeoutId : any;
          if (!hasNavigated) {
            if (response.data.location_type === "8") {
              timeoutId = setTimeout(() => navigate("/labtestArea"), 2000);
            } else if (response.data.location_type === "9") {
              timeoutId = setTimeout(() => navigate("/autoClave"), 2000);
            } else if (response.data.location_type === "12") {
              timeoutId = setTimeout(() => navigate("/incubationArea"), 2000);
            }
          }
          return () => clearTimeout(timeoutId);
        } catch (error) {
          console.error("Error processing area data", error);
        }
      } 
      // Handle 400 status or other errors
      else if (response.statusCode === 400) {
        setToastMessage(response.message);
        setToastType("error");
        setShowToast(true);
        dispatch(setAreaId(""));
        dispatch(setAreaName(""));
        dispatch(setScanAreaName(""));
        dispatch(setEquipmentId(""));
      }
  
    } catch (error) {
    }
    finally {
      setLoader(false);
    }
  };
  
  //display area details in the scan area nav 
  const data: Record<string, any> = {
    [t("operatorManagement.EquipmentName")]: scanAreaName,
    // "Capacity": capacityDetails
  };

  //map the capacity details
  if (capacityDetails && capacityDetails.length > 0) {
    data["Capacity"] = capacityDetails;
    data["Temperature"] = temperatureRange;
  }
 
  //list inprogress plate details for incubation area 
  const ListPlateDetails = async (areaId: any) => {
      try {
        const response = await userService.ListPlateDetails(pageHistory, pageSizeHistory, "id", "asc", "12", keyWordHistory, areaId);
        if(response.status && response.statusCode === 200){
          try {
              if ( Array.isArray(response.data) && response.data?.length > 0) {
                setTotalPagesHistory(response?.totalPages)
                setTotalElementsHistory(response?.totalElements)
                let rowData: any = response.data.map((element: any, index: number) => {
  
                  const plateType = parseInt(element.plate_type, 10);
                  let plateTypeStatus = userService.plateType(plateType);
                    
                    const statusNumber = parseInt(element.plate_status, 10); 
                    if(statusNumber == 9 || statusNumber == 1){
                      var status = "Pending"
                    }else if (statusNumber == 12){
                      var status = "In Progress"
                    }else if (statusNumber == 13){
                      var status = "Completed"
                    }else{
                      var status = "Unknown status"
                    }
                    interface Exposure {
                    id: string;
                    start_date_time: string;
                    end_date_time: string;
                    updated_by_first_name: string;
                    updated_by_last_name: string;
                    exposure_area_name: string;
                  }
                  // Calculate total exposed time
                  const exposureDetails : Exposure[] = element.exposure_details || [];
                  let totalExposedTime = 0;
                  let startTime, endTime;

                  exposureDetails.forEach((exposure) => {
                    const startDate = new Date(exposure.start_date_time);
                    const endDate = new Date(exposure.end_date_time);
                    const timeDifferenceMs = endDate.getTime() - startDate.getTime();
                    totalExposedTime += timeDifferenceMs;
  
                  });
                  const totalExposedTimeHours = Math.floor(totalExposedTime / 3600000);
                  const totalExposedTimeMinutes = Math.floor(
                    (totalExposedTime % 3600000) / 60000
                  );
                  const totalExposedTimeSeconds = Math.floor((totalExposedTime % 60000) / 1000);
                  const fullNames = exposureDetails.map((exposure : Exposure) => {
                    return `${exposure.updated_by_first_name} ${exposure.updated_by_last_name}`;
                  });
                  const exposed_user = fullNames.join(", ");
                  const exposureAreaName = element.exposure_details[0]?.exposure_area_name || '-';
                  
                  const formattedStartDateTime = exposureDetails.map((exposure) => moment(exposure.start_date_time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD hh:mm:ss A'));
                  const formattedEndDateTime = exposureDetails.map((exposure) => moment(exposure.end_date_time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD hh:mm:ss A'));
                  //caluculate the total incubated time 
                  interface Incubation {
                    id: string;
                    start_date_time: string;
                    expected_end_time: string;
                    created_by_first_name: string;
                    updated_by_first_name: string;
                    updated_by_last_name: string;
                  }
                  const incubationDetails : Incubation[] = element.incubation_details || [];
                  let totalIncubatedTime = 0
                  // const incubationDuration = incubationDetails.map((incubation) => {
                    // const startDatetime = new Date(incubation.start_date_time);
                    // const endDatetime = incubation.end_date_time ? new Date(incubation.end_date_time) : null;
                  
                    // if (!endDatetime) {
                    //   return "-";
                    // }
                  
                    // const timeDifference = endDatetime.getTime() - startDatetime.getTime();
                    // const hours = Math.floor(timeDifference / 3600000); // 1 hour = 3600000 milliseconds
                    // const minutes = Math.floor((timeDifference % 3600000) / 60000); // 1 minute = 60000 milliseconds
                    // const seconds = Math.floor((timeDifference % 60000) / 1000);
                  
                    // return `${hours} : ${minutes} : ${seconds}`;
                    
                     incubationDetails?.forEach((incubation)=>{
                     const startDate = new Date(incubation.start_date_time);
                     const endDate = incubation.expected_end_time ? new Date(incubation.expected_end_time) : null;
                     if (endDate) {
                       const timeDifferenceMs = endDate.getTime() - startDate.getTime();
                       totalIncubatedTime += timeDifferenceMs;
                     }
                   });
                   const totalIncubatedTimeHours = Math.floor(totalIncubatedTime / 3600000);
                   const totalIncubatedTimeMinutes = Math.floor(
                     (totalIncubatedTime % 3600000) / 60000
                   );
                   const totalIncubatedTimeSeconds = Math.floor((totalIncubatedTime % 60000) / 1000);
                        

                  const fullNamesIncubation = incubationDetails.map((incubation : Incubation) => {
                    return `${incubation.updated_by_first_name} ${incubation.updated_by_last_name}`;
                  });
                  const incubated_user = fullNamesIncubation.join(", ");
                  const incubationAreaName = element.incubation_details[0]?.incubation_area_name || '-';
  
                  return { 
                      slno: index + 1, 
                      batch_id: element.batch_number,
                      production_schedule_name: element.production_schedule_name,
                      product_name: element.product_name,
                      serial_number: element.serial_number,
                      // plate_type: plateTypeStatus,
                      plate_type: element.assigned_activity_name,
                      exposure_start_time : formattedStartDateTime,
                      exposure_end_time : formattedEndDateTime,
                      exposed_time: `${totalExposedTimeHours} : ${totalExposedTimeMinutes} : ${totalExposedTimeSeconds}`,
                      exposed_by : exposed_user,
                      exposure_area_name : exposureAreaName,
                      incubation_duration: `${totalIncubatedTimeHours} : ${totalIncubatedTimeMinutes} : ${totalIncubatedTimeSeconds}`,
                      incubated_by : incubated_user,
                      incubation_area_name : incubationAreaName ,
                      status : status
                  };
                });
                setPlateDetailsHistory(rowData);
              }
            } catch (error) {
              console.log(error); 
            }
        } else {
          setPlateDetailsHistory([])
          setTotalPagesHistory(0)
          setTotalElementsHistory(0)
        }
      } catch (error) {
        console.error('Plate response', error);
      }
  };

  //list inprogress plates in autoclave area 
  const ListAutoclaveDetails = async () => {
      try {
        const response = await userService.ListAutoclaveDetails(pageHistory, pageSizeHistory, "id", "", autoclaveStatus, keyWordHistory, "", "" , "");
        if(response.status && response.statusCode === 200){
          try {
              if ( Array.isArray(response.data) && response.data?.length > 0) {
                setTotalPagesHistory(response?.totalPages)
                setTotalElementsHistory(response?.totalElements)
                let rowData: any = response.data.map((element: any, index: number) => {
  
                    const statusNumber = parseInt(element.plate_status, 10); 
                    let status: string;
                    switch (statusNumber) {
                    case 22:
                    case 17:
                    case 10:
                    case 7:
                    case 4:
                      status = "Pending";
                      break;
                    case 14:
                      status = "In Progress";
                      break;
                    case 15:
                      status = "Completed";
                      break;
                    default:
                      status = "Unknown status";
                  }
                    interface Exposure {
                    id: string;
                    start_date_time: string;
                    end_date_time: string;
                    updated_by_first_name: string;
                    updated_by_last_name: string;
                    exposure_area_name: string;
                  }
                  // Calculate total exposed time
                  const exposureDetails : Exposure[] = element.exposure_details || [];
                  let totalExposedTime = 0;
  
                  exposureDetails.forEach((exposure) => {
                    const startDate = new Date(exposure.start_date_time);
                    const endDate = new Date(exposure.end_date_time);
                    const timeDifferenceMs = endDate.getTime() - startDate.getTime();
                    totalExposedTime += timeDifferenceMs;
  
  
                  });
                  const totalExposedTimeHours = Math.floor(totalExposedTime / 3600000);
                  const totalExposedTimeMinutes = Math.floor(
                    (totalExposedTime % 3600000) / 60000
                  );
                  const totalExposedTimeSeconds = Math.floor((totalExposedTime % 60000) / 1000);

                  const fullNames = exposureDetails.map((exposure : Exposure) => {
                    return `${exposure.updated_by_first_name} ${exposure.updated_by_last_name}`;
                  });
                  const exposed_user = fullNames.join(", ");
                  const exposureAreaName = element.exposure_details[0]?.exposure_area_name || '-';
                  
  
                  //caluculate the total incubated time 
                  interface Incubation {
                    id: string;
                    start_date_time: string;
                    end_date_time: string;
                    created_by_first_name: string;
                    updated_by_first_name: string;
                    updated_by_last_name: string;
                  }
                  const incubationDetails : Incubation[] = element.incubation_details || [];
                  
                  const incubationDuration = incubationDetails.map((incubation) => {
                    const startDatetime = new Date(incubation.start_date_time);
                    const endDatetime = incubation.end_date_time ? new Date(incubation.end_date_time) : null;
                  
                    if (!endDatetime) {
                      return "-";
                    }
                  
                    const timeDifference = endDatetime.getTime() - startDatetime.getTime();
                    const hours = Math.floor(timeDifference / 3600000); // 1 hour = 3600000 milliseconds
                    const minutes = Math.floor((timeDifference % 3600000) / 60000); // 1 minute = 60000 milliseconds
                    const seconds = Math.floor((timeDifference % 60000) / 1000);
                  
                    return `${hours} : ${minutes} : ${seconds}`;
                  });           
                  
  
                  const fullNamesIncubation = incubationDetails.map((incubation : Incubation) => {
                    return `${incubation.updated_by_first_name} ${incubation.updated_by_last_name}`;
                  });
                  const incubated_user = fullNamesIncubation.join(", ");
                  const incubationAreaName = element.incubation_details[0]?.incubator_name || '-';
  
               
  
                  return { 
                      slno: index + 1, 
                      batch_id: element.batch_number,
                      production_schedule_name: element.production_schedule_name,
                      product_name: element.product_name,
                      serial_number: element.serial_number,
                      exposed_time: `${totalExposedTimeHours} : ${totalExposedTimeMinutes} : ${totalExposedTimeSeconds}`,
                      exposed_by : exposed_user,
                      exposure_area_name : exposureAreaName,
                      incubation_duration: incubationDuration ,
                      incubated_by : incubated_user,
                      incubation_area_name : incubationAreaName ,
                      status : status
                  };
                  
                });
                setPlateDetailsHistory(rowData);
              }
            } catch (error) {
              console.log(error); 
            }
        } else {
          setPlateDetailsHistory([]);
          setTotalPagesHistory(0)
          setTotalElementsHistory(0)
        }
      } catch (error) {
        console.error('Plate response', error);
      }
  };
  
  //handle pagination 
  const handlePageChange = (newPage: any, pageSize?: number) => {
    setPageHistory(newPage);
    if(pageSize) {
      setPageSize(pageSize)
    }
    setUseEffectRequired(true);
  };

  //trigger the function call when the page loads
  useEffect(() => {
    // getAreaByScan(areaId , "");
  }, [useEffectRequired]);

  //based on the stored area id keep the api call 
  useEffect(() => {
    if (areaName == "9") {
      ListAutoclaveDetails()
        // .then((response) => { 
        // })
        // .catch((error) => {     
        //   console.error(error);
        // });
    } else if (areaName == "12") {
      ListPlateDetails(areaId)
        // .then((response) => { 
        // })
        // .catch((error) => {     
        //   console.error(error);
        // });
    }
  }, [areaId]);

  return (
    <div>
      <HeaderSection />

      <PageHeader pageHeader={t("operator.scanArea")} />
      <CustomToast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={5000}
          message={toastMessage}
          toastType={toastType}
      /> 

      <div className="scanWrapLg">


        <div className="scanInputWrapLg p-1" style={{"width": "30%"}}>
          <input
            type="text"
            value={scanCode}
            // onChange={(e) => setScanCode(e.target.value)}
            onChange={(e) => handleScancodeChange(e.target.value)}

            placeholder={t("operatorManagement.scanOnly")}
            ref={textFieldRef}
          />
          {webcamResult ? (
            <p
              onClick={() => clearSelectedData()}
              className="scanAddText py-2 me-2 my-0 "
            >
              {t("operatorManagement.clear")}
            </p>
          ) : (
            <div 
            //onClick={handleModalOpen} 
            className="scanBg ">
              <BsQrCodeScan />
            </div>
          )}
        </div>

        <div className="scanInputWrapLg p-1 ms-3" style={{"width": "30%"}}>
          <input
            type="text"
            value={selectedScanCode}
            // onChange={(e) => setScanCode(e.target.value)}
            onChange={(e) => setSelectedScanCode(e.target.value)}

            placeholder={t("operatorManagement.typeSearch")}
            // ref={textFieldRef}
          />
{loader && <CustomLoader />}
          < IoSearchSharp 
                    fontSize={25} 
                    className='m-1' 
                    color='grey'
                    style={{"cursor":"pointer"}} 
                    onClick={() => getAreaByScan("", selectedScanCode)}
                    // getAreaByScan(scanData.id , scanData.location_type);

                />
         
        </div>
        {scanAreaName !== '' && (
          <div
            className="scannedDetailsWrap ps-3"
            // style={{ marginLeft: "20%" }}
          >
            <table className="mx-2">
              <tbody>
                {Object.keys(data).map((key) => (
                  <tr key={key}>
                    <td className="keyText">{key}</td>
                    <td className="px-3">:</td>
                    <td className="valueText">{data[key]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {/* <p className='keyText m-0'>Area Name : <span className='valueText'> Name</span></p>
                        <p className='keyText my-1'>Activity Status : <span className='valueText'> Status</span></p> */}
          </div>
        )}
      </div>
      {areaId !== '' && (
        <>
          <div className=" mx-3 pe-2" style={{"height":"45vh"}}>
            <CustomTable
              data={plateDetailsHistory}
              columns={columns}
              isEditable={false}
              totalElements={totalElementsHistory}
              isActionVisible={false}
              isViewVisible={false}
              tableHead=""
              showBatchFilter={false}
              showSerielNoFilter={false}
            />
          </div>
          <div>
            <Pagination
              page={pageHistory}
              totalPages={totalPagesHistory}
              handlePageChange={handlePageChange}
            />
          </div>
        </>
      )}

      <Modal show={showScan} >
        <div className="scanModal">
          <div className="modalHead">
            <p className="modalHeadText2 mx-3 my-2">{t("operatorManagement.scan")}</p>
            <div onClick={() => setShowScan(false)} className="p-2 mx-2 ">
              <TfiClose fill="#FFFFFF" />
            </div>
          </div>

          {/* Qr reader to open the camera and scan  */}
          <QrReader
            className="scan-web"
            delay={300}
            onError={webCamError}
            onScan={webCamScan}
            facingMode={"user"}
          />
        </div>
      </Modal>
    </div>
  );
};

export default ScanArea;
